<script>
    export default {
        name: 'ErrorBoundary',
        props: ['type'],
        data: () => ({
            error: false,
            errorDetails: '',
        }),
        errorCaptured (err, vm, info) {
            this.error = true;
            this.errorDetails = err;
            // console.error(err, vm, info);
            captureException(err);
        },
        render: function(createElement) {
            if(!this.error) {
                if(this.$slots.default) return this.$slots.default[0];
                return null;
            } else if(typeof this.$slots.error !== 'undefined') {
                return this.$slots.error[0];
            } else {
                switch (this.type) {
                    case 'list':
                        return createElement('div', {
                            'style': 'width: 100%; border-bottom: 1px solid rgba(0, 0, 0, 0.12)!important;',
                            'class': 'v-list__tile theme--light white text-xs-center'
                        }, [
                            createElement('div', {
                                'style': 'width: 100%; font-weight: 600; font-style: italic;position: relative; height: 100%;padding-top: 22px; color: rgba(155,0,0,.54)',
                                'class': 'white text-xs-left'
                            }, [
                                createElement(
                                    'i',
                                    {
                                        'class': 'v-icon material-icons theme--light',
                                        'style': 'margin: 0 18px 0 8px',
                                    },
                                    'alert_outline'
                                ),
                                createElement('span', 'Nem jeleníthető meg a kért adat.')
                            ])
                        ]);
                    default:
                        return createElement('p', '' + this.errorDetails);
                }
            }
        },
    }
</script>
